<template>
  <div class="salegoods-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:150px"
                  placeholder="请选择状态">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.is_hot"
                  clearable
                  style="width:80px"
                  placeholder="热卖">
            <Option v-for="item in hotList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.is_pos"
                  clearable
                  style="width:80px"
                  placeholder="推荐">
            <Option v-for="item in posList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入商品名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('1')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Tabs v-model="step">
        <TabPane label="基础信息"
                 name="firstStep">
          <Form :model="goods"
                :label-width="80"
                ref="goodsValidate"
                :rules="goodsValidate">
            <Row>
              <Col span="8">
              <FormItem label="商品分类"
                        label-position="top"
                        prop="selectCate">
                <Select filterable
                        clearable
                        multiple
                        placeholder="请选择"
                        v-model="pselectCate"
                        @on-change="XiangChange">
                  <Option v-for="(item,index) in cateList"
                          :key="index"
                          :label="item.name"
                          :value="item.id" />
                </Select>
                <Select filterable
                        multiple
                        clearable
                        v-model="selectCate"
                        @on-change="cateSelect"
                        placeholder="请选择">
                  <Option v-for="(item,index) in scateList"
                          :key="index"
                          :label="item.name"
                          :value="item.id" />
                </Select>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="商品类型"
                        label-position="top"
                        prop="salecate_id">
                <Select v-model="goods.salecate_id"
                        clearable
                        filterable
                        placeholder="选择类型">
                  <Option v-for="item in salecateList"
                          :value="item.id"
                          :key="item.id">{{item.name}}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="品牌"
                        label-position="top">
                <Select v-model="goods.brand_id"
                        clearable
                        filterable
                        placeholder="选择品牌">
                  <Option v-for="item in brandList"
                          :value="item.id"
                          :key="item.id">{{item.name}}</Option>
                </Select>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
              <FormItem label="商品标题"
                        label-position="top"
                        prop="title">
                <Input v-model="goods.title"
                       placeholder="商品标题">></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="发票信息"
                        label-position="top">
                <Input v-model="goods.invoice_title"
                       placeholder="货物名称；规格型号；单位；数量"></Input>
              </FormItem>
              </Col>
            </Row>
            <FormItem label="商品规格"
                      label-position="top">
              <Row>
                <Col span="5">
                <Input v-model="goodsSpec"
                       placeholder="颜色/尺寸/重量"></Input>
                </Col>
                <Col span="5">
                <Input v-model="goodsSpecItem"
                       placeholder="红黄蓝/1CM*2CM/1KG"></Input>
                </Col>
                <Col span="14">
                <Button style="float:left"
                        type="info"
                        @click="addSpec(goods.id)">添加</Button>
                <Alert style="float:left"
                       type="error">若填写商品规格，则上方的开票信息不必填写，只需填写按规格对应的开票信息</Alert>
                </Col>
              </Row>
            </FormItem>

            <!--规格下拉选开始-->
            <Card style="margin-top:20px;margin-left: 80px;"
                  v-if="goodsSpecType.length !=0 ">
              <Form>
                <FormItem v-for="(spec) in goodsSpecType"
                          :key="spec.id"
                          :label="spec.name">
                  <Row>
                    <tag v-for="item in spec.goodspecitem"
                         :key="item.id"
                         style="margin-right:10px;height:30px;line-height:30px;">{{item.item}}</tag>
                    <Button type="info"
                            style="margin-right:10px;margin-left: 10px;"
                            @click="editSpec(spec)">编辑</Button>
                    <Button type="error"
                            style="margin-right:10px;"
                            @click="deleteSpec(spec)">删除</Button>
                  </Row>
                </FormItem>
              </Form>
            </Card>
            <!--规格下拉选结束-->
            <!--规格列表开始-->
            <Card style="margin-top:20px;margin-left: 80px;"
                  v-for="(goodsSpec,specindex) in goodsSpecList"
                  :key="goodsSpec.good_spec_key">
              <Row style="margin-top:10px;">
                <Col span="22">
                <tag v-for="(spec,index) in goodsSpec.specList"
                     :key="spec.name"
                     style="margin-right:10px;height:30px;line-height:30px;"
                     :color="getTagColor(index)">{{spec.name+':'+spec.item}}</tag>
                </Col>
              </Row>
              <Row style="margin-top:10px;">
                <Col span="8"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.good_store"
                       style="margin-left:6px"
                       placeholder="请输入库存">
                <span slot="prepend">库存</span>
                </Input>
                </Col>
                <Col span="8"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.good_price"
                       style="margin-left:6px"
                       placeholder="请输入价格">
                <span slot="prepend">价格</span>
                </Input>
                </Col>
                <Col span="8"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.new_platprice"
                       style="margin-left:6px"
                       placeholder="请输入平台进价">
                <span slot="prepend">平台进价</span>
                </Input>
                </Col>
                <Col span="8"
                     style="padding-right:30px;padding-top:2px;">
                <Input v-model="goodsSpec.invoice_title"
                       style="margin-left:6px"
                       placeholder="货物名称；规格型号；单位；数量">
                <span slot="prepend">发票信息</span>
                </Input>
                </Col>
                <Col span="4"
                     style="padding-right:30px;padding-top:2px;">
                <upload-thumb v-model="goodsSpec.thumb"
                              :ref="'goodsUploadthumb'+specindex"
                              :defaultList="goodsSpec.thumblist"
                              :autoCropWidth="320"
                              :autoCropHeight="320"
                              :defaultTip="'建议图片尺寸:320*320'"></upload-thumb>
                </Col>
              </Row>
            </Card>
            <!--规格列表结束-->
            <Tabs v-model="cateShow"
                  value="cate"
                  tab="tab2"
                  @on-click="cateShowClick">
              <TabPane :label="cate.name"
                       :name="cate.id"
                       tab="tab2"
                       v-for="(cate, i) in cateShowList"
                       :key="i">
              </TabPane>
            </Tabs>
            <FormItem v-for="attr in goodsShowAttr"
                      :key="attr.id"
                      :label="'*'+ attr.name"
                      label-position="top"
                      style="margin-top: 10px">
              <Input v-model="attr.detail"></Input>
            </FormItem>
            <!-- <FormItem v-for="attr in goodsAttrList"
                      :key="attr.id"
                      :label="attr.name"
                      label-position="top"
                      style="margin-top: 10px">
              <Input v-model="attr.detail"></Input>
            </FormItem> -->
            <Row>
              <Col span="8">
              <FormItem label="生产地"
                        label-position="top">
                <Input v-model="goods.place"></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="库存"
                        label-position="top"
                        prop="store">
                <Input v-model="goods.store"></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="默认价格"
                        label-position="top"
                        prop="prices">
                <Input v-model="goods.prices"></Input>
              </FormItem>
              </Col>
            </Row>
            <FormItem label="关键字"
                      label-position="top"
                      prop="keyword">
              <Input v-model="goods.keyword"></Input>
            </FormItem>
            <FormItem label="描述"
                      label-position="top"
                      prop="describe">
              <Input type="textarea"
                     v-model="goods.describe"
                     :rows="3"
                     placeholder="请输入描述" />
            </FormItem>

            <Row>
              <Col span="8">
              <FormItem label="选择供应商"
                        label-position="top"
                        prop="tradesman_id">
                <Select v-model="goods.from_uuid"
                        clearable
                        filterable
                        placeholder="请搜索供应商"
                        :remote-method="remoteMethod1"
                        @on-change="changePlatePrice">
                  <Option v-for="item in trandList"
                          :value="item.seller_uuid"
                          :key="item.seller_uuid">{{(item.nickname!=null&& item.nickname!='')?item.nickname:((item.company!=null&& item.company!='')?item.company:item.name)}}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="上架时间"
                        prop="lasttime">
                <DatePicker v-model="goods.lasttime"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="上架时间"
                            style="width: 200px"
                            @on-change="changeDateOne"></DatePicker>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="下架时间"
                        prop="lowertime">
                <DatePicker v-model="goods.lowertime"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="下架时间"
                            style="width: 200px"
                            @on-change="changeDateTwo"></DatePicker>
              </FormItem>
              </Col>
            </Row>
            <FormItem label="缩略图"
                      prop="thumb">
              <upload-thumb v-model="goods.thumb"
                            ref="uploadthumb"
                            :defaultList="thumblist"
                            :autoCropWidth="320"
                            :autoCropHeight="320"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:320*320,大小不超过2M'"></upload-thumb>
            </FormItem>
            <FormItem label="相册"
                      prop="album">
              <upload-thumb v-model="goods.album"
                            ref="uploadthumbTwo"
                            :defaultList="thumblistTwo"
                            :autoCropWidth="750"
                            :autoCropHeight="600"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*600,大小不超过2M'"></upload-thumb>
            </FormItem>
            <FormItem label="内容"
                      prop="content">
              <!--                            <editor-bar v-model="goods.content" :isClear="isClear" ref="editContent" @change="change"></editor-bar>-->
              <UEditor v-model="goods.content"
                       :isClear="isClear"
                       ref="editContent"
                       @change="change"></UEditor>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="营销信息"
                 name="secondStep">
          <Form :model="goods"
                :label-width="80">
            <Row>
              <Col span="6">
              <FormItem label="是否支持7天无理由退货"
                        label-position="top">
                <RadioGroup v-model="goods.is_seven_return">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否推荐"
                        label-position="top">
                <RadioGroup v-model="goods.is_pos">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否热卖"
                        label-position="top">
                <RadioGroup v-model="goods.is_hot">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否新品"
                        label-position="top">
                <RadioGroup v-model="goods.is_new">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="6">
              <FormItem label="是否自营"
                        label-position="top">
                <RadioGroup v-model="goods.is_self">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="5">
              <FormItem label="进价比例"
                        label-position="top">
                <Input v-model="goods.platprice">
                <span slot="append">%</span>
                </Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="平台进价"
                        label-position="top">
                <!-- <Input
                    v-model="goods.new_platprice"
                    :disabled="maxPlatPrice == null"
                    :style="{width:'80px',float:'left',marginRight:'10px'}"
                  >
                    <span slot="append">%</span>
                  </Input>-->
                <!-- <Input
                    v-model="goods.new_platprice"
                    :style="{width:'80px',float:'left',marginRight:'10px'}"
                  ></Input>-->
                <Input v-model="goods.new_platprice"
                       placeholder="平台进价"></Input>
                <!-- <i
                    v-if="maxPlatPrice != null"
                    style="color:gray;font-style:normal; font-size:12px;display:block;"
                  >
                    {{ taxPoint != null ? ('*您需要开具税点为（' + taxPoint + '%）') : '' }}
                    {{ invoiceType != null ? ( invoiceType == 0 ? '的（普通发票）' : '的（专用发票）') : '' }}
                    {{ maxPlatPrice != null ? ('，平台进价最高设定为（' + maxPlatPrice + '%）') : '，（未设置最高平台进价）' }}
                  </i>-->
                <!-- <div style="clear:both;" v-else>&nbsp;</div> -->
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="排序"
                        label-position="top">
                <Input v-model="goods.sort"></Input>
              </FormItem>
              </Col>
            </Row>
          </Form>
        </TabPane>
      </Tabs>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false;step='firstStep'">取消</Button>
        <Button type="primary"
                @click="creategoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
    <Modal v-model="showEditSpec"
           title="修改规格"
           @on-ok="editSpecDone"
           @on-cancel="editSpecCancel"
           :loading="editSpecLoading">
      <Form :model="goods"
            :label-width="60"
            ref="goodsValidate1"
            :rules="goodsValidate">
        <FormItem label="名称"
                  label-position="top">
          <Input v-model="editSpecDetail.name"></Input>
        </FormItem>
        <FormItem label="规格项"
                  label-position="top">
          <Row v-for="(item,index) in editSpecDetail.goodspecitem">
            <Col span="10">
            <Input v-model="item.item"></Input>
            </Col>
            <Col span="6">
            <Button type="primary"
                    shape="circle"
                    icon="ios-trash-outline"
                    @click="deleteSpecItem(item,index)" />
            </Col>
          </Row>
        </FormItem>
      </Form>
      <Button type="primary"
              @click="addNewSpec()">添加新规格项</Button>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
import uploadthumbTwo from "../common/thumb";
export default {
  name: "salegoods-list",
  data () {
    const validateSelectCate = (rule, value, callback) => {
      if (this.selectCate == "" || this.selectCate == null || this.selectCate == undefined) {
        callback(new Error("请选择商品分类"));
      } else {
        callback();
      }
    };
    const validateTradesmanId = (rule, value, callback) => {
      if (
        this.goods.from_uuid == "" ||
        this.goods.from_uuid == null ||
        this.goods.from_uuid == undefined
      ) {
        callback(new Error("请选择供应商"));
      } else {
        callback();
      }
    };
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传缩略图"));
      } else {
        callback();
      }
    };
    const validateThumbTwo = (rule, value, callback) => {
      if (this.$refs["uploadthumbTwo"].uploadList.length == 0) {
        callback(new Error("请上传相冊"));
      } else {
        callback();
      }
    };
    const validateContent = (rule, value, callback) => {
      if (this.goods.content == "") {
        callback(new Error("内容必须填写"));
      } else {
        callback();
      }
    };
    const validatePirces = (rule, value, callback) => {
      if (
        this.goods.prices == "" ||
        this.goods.prices == null ||
        this.goods.prices == undefined
      ) {
        callback(new Error("价格必须填写"));
      } else {
        callback();
      }
    };
    const validateStore = (rule, value, callback) => {
      if (
        this.goods.store == "" ||
        this.goods.store == null ||
        this.goods.store == undefined
      ) {
        callback(new Error("库存必须填写"));
      } else {
        callback();
      }
    };
    const validateSalecateId = (rule, value, callback) => {
      if (
        this.goods.salecate_id == "" ||
        this.goods.salecate_id == null ||
        this.goods.salecate_id == undefined
      ) {
        callback(new Error("商品分类必须填写"));
      } else {
        callback();
      }
    };

    return {
      goodsSpecList: [],
      step: "firstStep",
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      editSpecLoading: true,
      goodsSpec: "", //添加的规格
      goodsSpecItem: "", //添加的规格名称
      goodsSpecType: [], //规格列表
      // goodsSpecType: [{'spec':'颜色','items':[{'id':1,'name':'红','isSelect':false},{'id':2,'name':'蓝','isSelect':false}]},{'spec':'重量','items':[{'id':3,'name':'1KG','isSelect':false},{'id':4,'name':'2KG','isSelect':false}]}],//规格列表
      goodsSpecDetail: [], //商品规格数据
      specList: [], //规格展示列表
      specDataList: [], //规格数据展示列表
      showEditSpec: false, //是否显示编辑规格页面
      editSpecDetail: {},
      goodsAttrList: [],
      goodsShowAttr: [],
      cateShowList: [],
      cateShow: '',
      goods: {
        title: "",
        keyword: "",
        describe: "",
        content: "",
        thumb: "",
        album: "",
        is_platprice: "1",
        is_cloud: "0",
        is_pos: "0",
        is_hot: "0",
        is_new: "0",
        is_self: "0",
        prices: null,
        store: null,
        new_platprice: "0",
        sort: "0",
        is_seven_return: "0",
        lasttime: "",
        lowertime: "",
        from_uuid: ""
      },
      editor: {
        ifno: ""
      },
      isClear: false,
      loading: true,
      dataloading: true,
      thumblist: [],
      thumblistTwo: [],
      cateList: [], // 请求分类
      scateList: [],
      selectCate: [],
      pselectCate: [],
      selectCateId: "",
      datePic: [],
      brandList: [],
      salecateList: [],
      trandList: [],
      statusList: [
        { id: 1, name: "正常" },
        { id: 0, name: "下架" }
      ],
      hotList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      posList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      isable: true,
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "good_id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "good_title",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.good_title),
              h(
                "span",
                {
                  style: {
                    marginLeft: "5px",
                    color: "#a94442"
                  }
                },
                "图"
              )
            ]);
          }
        },
        {
          title: "供应商",
          key: "nickname",
          minWidth: 150
        },
        {
          title: "供应商商品类型",
          key: "salecate",
          minWidth: 100
        },
        {
          title: "分类",
          key: "good_cate",
          minWidth: 150,
          render: (h, params) => {
            return h("div", [h("span", {}, params.row.good_cate)]);
          }
        },
        {
          title: "库存",
          key: "good_store",
          minWidth: 80
        },
        {
          title: "销量",
          key: "good_sales",
          minWidth: 80
        },
        {
          title: "状态",
          key: "good_status",
          minWidth: 80
        },
        {
          title: "修改时间",
          key: "good_updated",
          minWidth: 150
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            if (params.row.good_status == "在售") {
              return h("div", [
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.detail(params.row.good_id);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.remove(params.row.good_id, 0, params.row.create_type);
                      }
                    }
                  },
                  "下架"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "info",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.copyGoods(params.row.good_id, 2)
                      }
                    }
                  },
                  '复制'
                )
              ]);
            } else {
              return h("div", [
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.detail(params.row.good_id);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.remove(params.row.good_id, 1, params.row.create_type);
                      }
                    }
                  },
                  "上架"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "info",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.copyGoods(params.row.good_id, 2)
                      }
                    }
                  },
                  '复制'
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.remove(params.row.good_id);
                      }
                    }
                  },
                  "删除"
                )

              ]);
            }
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      goodsValidate: {
        title: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        // salecate_id: [
        //   {
        //     required: true,
        //     validator: validateSalecateId,
        //     trigger: "change"
        //   }
        // ],
        keyword: [
          { required: true, message: "关键词必须填写", trigger: "blur" }
        ],
        describe: [
          { required: true, message: "描述必须填写", trigger: "blur" }
        ],
        platprice: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let n = new RegExp(/^\d{1,}$/);
              if (this.maxPlatPrice == null) {
                callback(new Error("未设置最高平台进价"));
              }
              // if (!n.test(this.goods.platprice)) {
              //     callback(new Error('必须填数字'));
              // } else if (this.goods.platprice <= 0) {
              //     callback(new Error('必须大于0'));
              // } else
              if (this.goods.new_platprice > this.maxPlatPrice) {
                callback(new Error("不得大于" + this.maxPlatPrice));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        content: [
          { required: true, validator: validateContent, trigger: "change" }
        ],
        selectCate: [
          { required: true, validator: validateSelectCate, trigger: "change" }
        ],
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],
        album: [
          { required: true, validator: validateThumbTwo, trigger: "change" }
        ],
        prices: [
          { required: true, validator: validatePirces, trigger: "blur" }
        ],
        tradesman_id: [
          {
            required: true,
            validator: validateTradesmanId,
            trigger: "change"
          }
        ],
        store: [{ required: true, validator: validateStore, trigger: "blur" }],
        lasttime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.lasttime == "") {
                callback(new Error("上架架时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        lowertime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.lasttime == "") {
                callback(new Error("下架时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      id: 0,
      maxPlatPrice: null, // 新建/编辑时，选择供应商后更新此值，用于限制平台进价上限；null时禁止修改平台进价
      taxPoint: null, // 税点
      invoiceType: null // 0普通/1专有发票
    };
  },
  created: function () {
    this.from_uuid = this.$route.query.from_uuid;
    this.getTableList();
    this.getBrandList();
    this.getSaleCateList();
    this.getTrandList();
    this.getCate();
  },
  components: {
    UploadThumb,
    UEditor,
    uploadthumbTwo
  },

  methods: {
    copyGoods (id, type) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>确定要复制此商品吗?</p>",
        onOk: () => {
          this.$api.goods.copy({ id: id, type: type }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
            }
          });
        }
      });
    },
    getTableList: function () {
      this.$api.goods
        .list({
          page: this.pages.page,
          from_uuid: this.from_uuid,
          size: this.pages.size,
          is_platprice: "1"
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    getBrandList () {
      this.$api.goodbrand.list().then(res => {
        if (res.code == 200) {
          this.brandList = res.result.list;
        }
      });
    },
    getSaleCateList () {
      this.$api.salegoodcate.list().then(res => {
        if (res.code == 200) {
          this.salecateList = res.result.list;
        }
      });
    },
    remoteMethod1 (query) {
      if (query !== '') {
        this.$api.seller.list({ page: 1, size: 50, key: query }).then(res => {
          if (res.code == 200) {
            this.trandList = res.result.list;
          }
        });
      } else {
        this.trandList = [];
      }

    },
    // 获取分类getCate
    getCate: function () {
      this.$api.goodcate.select().then(res => {
        if (res.code == 200) {
          this.cateList = res.result;
        }
      });
      return;
    },
    XiangChange (index) {
      this.$api.goodcate.select({ parent_id: index }).then(res => {
        if (res.code == 200) {
          this.scateList = res.result;
        }
      });
      return;
    },
    cateSelect: function (value, selectedData) {
      this.getAttrData(this.selectCate);
      // var end = selectedData[selectedData.length - 1];
      // this.selectCateId = end.value;
      // this.goodsAttrList = [];
      // this.getAttrData(this.selectCateId);
    },
    //规格
    //删除规格
    deleteSpec (spec) {
      var params = { good_spec_id: spec.id };
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作会删除所有规格，且不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goodspec.remove(params).then(res => {
            if (res.code == 200) {
              var list = this.goodsSpecType;
              for (let i = 0; i < list.length; i++) {
                const goodsSpec = list[i];
                if (goodsSpec.id == spec.id) {
                  list.splice(i, 1);
                }
              }
              this.goodsSpecType = list;
              this.goodsSpec = "";
              this.goodsSpecDetail = [];
              this.specList = [];
              this.showAllSepc()
            }
          });
        }
      });
    },
    //编辑规格
    editSpec (spec) {
      this.showEditSpec = true;
      this.editSpecDetail = spec;
    },
    editSpecDone () {
      var items = [];
      for (
        let index = 0;
        index < this.editSpecDetail.goodspecitem.length;
        index++
      ) {
        const specItem = this.editSpecDetail.goodspecitem[index];
        if (
          specItem.item &&
          specItem.item != undefined &&
          specItem.item != ""
        ) {
          items.push(specItem.item);
        }
      }
      var good_id = this.goods.id;
      if (good_id == null || good_id == undefined || good_id == "") {
        good_id = this.tempId;
      }
      var that = this;
      var params = {
        good_id: good_id,
        good_spec_id: this.editSpecDetail.id,
        goodspec: this.editSpecDetail.name,
        goodspecitem: items
      };
      this.$api.goodspec.edit(params).then(res => {
        if (res.code == 200) {
          this.editSpecLoading = false;

          this.$nextTick(() => {
            that.editSpecLoading = true;
            that.showEditSpec = false;
          });
          this.$api.goodspec.specDetail({ gid: good_id }).then(res => {
            if (res.code == 200) {
              that.goodsSpecType = res.result;
              that.showAllSepc();
            }
          });
        }
      });
    },
    editSpecCancel () {
      if (
        this.goods.id == null ||
        this.goods.id == 0 ||
        this.goods.id == undefined
      ) {
        this.goods.id = this.tempId;
      }
      this.$api.goodspec.specDetail({ gid: this.goods.id }).then(res => {
        if (res.code == 200) {
          this.goodsSpecType = res.result;
          this.showAllSepc();
        }
      });
    },
    addNewSpec () {
      var detail = this.editSpecDetail;
      var items = detail.goodspecitem;
      if (items == null || items == undefined) {
        items = [];
      }
      items.push({ item: "" });
      detail.goodspecitem = items;
      this.editSpecDetail = detail;
    },
    deleteSpecItem (item, index) {
      var detail = this.editSpecDetail;
      var items = detail.goodspecitem;
      if (items.length <= 1) {
        return;
      }
      items.splice(index, 1);
      detail.goodspecitem = items;
      this.editSpecDetail = detail;
    },
    //添加规格
    addSpec (id) {
      if (
        this.goodsSpec == null ||
        this.goodsSpec == undefined ||
        this.goodsSpec == "" ||
        this.goodsSpecItem == null ||
        this.goodsSpecItem == undefined ||
        this.goodsSpecItem == ""
      ) {
        this.$toast("规格和规格项不能为空");
        return;
      }
      if (id == null || id == undefined) {
        id = this.tempId;
      }
      var params = {
        gid: id,
        goodspec: this.goodsSpec,
        goodspecitem: this.goodsSpecItem
      };
      this.$api.goodspec.create(params).then(res => {
        if (res.code == 200) {
          this.goodsSpecType = res.result;
          this.goodsSpec = null;
          this.goodsSpecItem = null;
          this.showAllSepc();
        }
      });
    },
    changeDateTwo (val) {
      this.goods.lowertime = val;
    },
    changeDateOne (val) {
      this.goods.lasttime = val;
    },
    // 展开添加
    showModel () {
      this.tempId = (new Date().getTime() / 1000).toFixed();
      this.title = "添加商品";
      this.goods = {
        title: "",
        keyword: "",
        describe: "",
        content: "",
        thumb: "",
        album: "",
        from_uuid: "",
        is_cloud: "0",
        is_pos: "0",
        is_hot: "0",
        is_new: "0",
        is_self: "0",
        is_made: "0",
        is_fx: "0",
        seller_name: "0",
        is_seven_return: "0",
        agent_fx: 0,
        sort: "0"
      };
      this.isable = true;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.selectCateId = "";
      this.selectCate = [];
      this.goodsShowAttr = [];
      this.goodsAttrList = [];
      (this.goodsSpec = ""), //添加的规格
        (this.goodsSpecItem = ""), //添加的规格名称
        (this.goodsSpecType = []), //规格列表
        (this.goodsSpecDetail = []), //商品规格数据
        (this.specList = []), //规格展示列表
        (this.specDataList = []),
        this.$refs["goodsValidate"].resetFields();
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      var d1 = new Date();
      var d2 = new Date();
      d2.setFullYear(d1.getFullYear() + 1);
      this.goods.lasttime = this.formatDate(d1, "yyyy-MM-dd hh:mm:ss");
      this.goods.lowertime = this.formatDate(d2, "yyyy-MM-dd hh:mm:ss");
      this.showModalStatus = !this.showModalStatus;
      this.goodsSpecList = [];
    },
    // 改变分销比例
    agentFx: function (val) {
      // 返回的是 lable值
      if (val == "1") {
        this.isable = false;
      } else {
        this.isable = true;
      }
    },
    // 详情
    detail (id) {
      // this.getSpec(id);
      this.title = "编辑商品";
      this.goodsAttrList = [];
      (this.goodsSpec = ""), //添加的规格
        (this.goodsSpecItem = ""), //添加的规格名称
        (this.goodsSpecType = []), //规格列表
        (this.goodsSpecDetail = []), //商品规格数据
        (this.specList = []), //规格展示列表
        (this.specDataList = []),
        (this.thumblist = new Array());
      this.thumblistTwo = new Array();
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = true;
      this.$api.goods.detail({ good_id: id }).then(res => {
        this.selectCate = res.result.goodcate;
        this.pselectCate = res.result.pgoodcate;
        this.XiangChange(res.result.pgoodcate)
        if (this.selectCate.length > 0) {
          this.getAttrData(this.selectCate);
        }
        this.goods = res.result;
        this.remoteMethod1(this.goods.seller_name);
        this.goods.is_platprice = res.result.goodset.is_platprice.toString();
        this.goods.is_cloud = res.result.goodset.is_cloud.toString();
        this.goods.is_pos = res.result.goodset.is_pos.toString();
        this.goods.is_hot = res.result.goodset.is_hot.toString();
        this.goods.is_new = res.result.goodset.is_new.toString();
        this.goods.is_self = res.result.goodset.is_self.toString();
        this.goods.platprice = res.result.goodset.platprice.toString();
        this.goods.new_platprice = res.result.goodset.new_platprice;
        this.goods.is_seven_return = res.result.goodset.is_seven_return.toString();
        // this.$refs['editContent'].editor.txt.html(res.result.content);
        this.$refs["editContent"].message = res.result.content;
        this.goodsSpecType = res.result.goodspec;
        this.goodsSpecList = res.result.specList;
        this.showAllSepc();
        //处理thumb
        if (this.goods.thumb != null && this.goods.thumb != "") {
          this.thumblist.push({
            name: this.goods.thumb,
            url: this.goods.thumb,
            status: "finished"
          });
        }
        if (this.goods.album != null && this.goods.album.length > 0) {
          for (var s in this.goods.attrShow) {
            this.thumblistTwo.push({
              name: this.goods.attrShow[s],
              url: this.goods.attrShow[s],
              status: "finished"
            });
          }
        }


        // 设置平台进价最大值
        this.changePlatePrice(res.result.from_uuid);
      });
    },
    //商品属性
    getAttrData (id) {

      var showAttrList = []
      for (let i = 0; i < id.length; i++) {
        const scateid = id[i];
        for (let j = 0; j < this.scateList.length; j++) {
          let scate = this.scateList[j]
          if (scateid == scate.id) {
            showAttrList.push(scate)
            break
          }
        }
        if (i == 0) {
          this.cateShow = scateid
        }
      }
      this.cateShowList = showAttrList

      this.$api.goodattr.list({ cate_id: id, page: 1, size: 999 }).then(res => {
        if (res.code == 200) {
          var attrList = res.result.list == null ? [] : res.result.list;
          var goodsAttr = this.goods.goodattrdata;
          if (goodsAttr == null || goodsAttr == undefined) {
            goodsAttr = [];
          }
          for (let i = 0; i < attrList.length; i++) {
            var attr = attrList[i];
            for (let j = 0; j < goodsAttr.length; j++) {
              const g = goodsAttr[j];
              attr.detail = "";
              if (
                attr.id == g.good_attr_id &&
                g.good_attr_value != null &&
                g.good_attr_value != "null"
              ) {
                let a = g.good_attr_value; //eval('(' +g.good_attr_value + ')');
                a = this.unicode2Ch(a);
                attr.detail = a.replace(/\"/g, "");
                break;
              }
            }
          }
          this.goodsAttrList = attrList;
          if (showAttrList.length > 0) {
            this.cateShowClick(showAttrList[0].id)
          }
        }
      });
    },
    cateShowClick (cate) {
      let goodsShowAttr = []
      for (let i = 0; i < this.goodsAttrList.length; i++) {
        const attr = this.goodsAttrList[i];
        if (attr.good_cate_id == cate) {
          goodsShowAttr.push(attr)
        }
      }
      this.goodsShowAttr = goodsShowAttr
    },
    // 字符转码
    unicode2Ch (str) {
      if (!str) {
        return;
      }
      // 控制循环跃迁
      var len = 1;
      var result = "";
      // 注意，这里循环变量的变化是i=i+len 了
      for (var i = 0; i < str.length; i = i + len) {
        len = 1;
        var temp = str.charAt(i);
        if (temp == "\\") {
          // 找到形如 \u 的字符序列
          if (str.charAt(i + 1) == "u") {
            // 提取从i+2开始(包括)的 四个字符
            var unicode = str.substr(i + 2, 4);
            // 以16进制为基数解析unicode字符串，得到一个10进制的数字
            result += String.fromCharCode(parseInt(unicode, 16).toString(10));
            // 提取这个unicode经过了5个字符， 去掉这5次循环
            len = 6;
          } else {
            result += temp;
          }
        } else {
          result += temp;
        }
      }
      return result;
    },
    // 添加
    creategoods (name) {
      if (this.goodsSpecList && this.goodsSpecList.length > 0) {
        for (let i = 0; i < this.goodsSpecList.length; i++) {
          var goodsSpec = this.goodsSpecList[i];
          var key = "goodsUploadthumb" + i.toString();
          var upload = null;
          if (this.$refs[key]) {
            if (this.$refs[key].length > 0) {
              upload = this.$refs[key][0];
            } else {
              upload = this.$refs[key];
            }
          }
          if (upload.uploadList.length > 0) {
            goodsSpec.thumb = upload.uploadList[0].url;
          }
        }
      }
      this.goods.goodspec = [];
      this.goods.goodspecprice = [];
      this.goods.specList = [];
      this.goods.content = this.$refs["editContent"].message;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.goods.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          }
          //相册
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumbTwo"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.goods.album = finalAttrs.substring(0, finalAttrs.length - 1);
            }
          }
          if (this.selectCate) {
            this.goods.cate_id = this.selectCate;
          }
          //商品规格
          if (this.goodsSpecList.length > 0) {
            this.goods.spec_item = this.goodsSpecList;
          }
          var good_attr = [];
          for (let i = 0; i < this.goodsAttrList.length; i++) {
            const attr = this.goodsAttrList[i];
            var good_a = {
              good_attr_id: attr.id,
              good_attr_value: attr.detail
            }; //  == undefined ? null : attr.detail
            good_attr.push(good_a);
          }
          this.goods.good_attr = good_attr;
          // console.log('this.goods.good_attr',this.goods.good_attr)
          this.goods.lasttime = this.formatDate(
            this.goods.lasttime,
            "yyyy-MM-dd hh:mm:ss"
          );
          this.goods.lowertime = this.formatDate(
            this.goods.lowertime,
            "yyyy-MM-dd hh:mm:ss"
          );
          if (
            this.goods.id == null ||
            this.goods.id == 0 ||
            this.goods.id == undefined
          ) {
            this.goods.id = this.tempId;
            this.goods.is_platprice = 1;
            this.$api.goods.create(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
                this.step = "firstStep";
              }
              this.loading = false;
              this.goods.id = null;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          } else {
            this.$api.goods.edit(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
                this.step = "firstStep";
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function (id, type, create_type) {
      if (type != 0 && type != 1) {
        // 弹出确认框
        this.$Modal.confirm({
          title: "警告",
          content: "<p>此操作不可恢复，三思而后行...</p>",
          onOk: () => {
            this.$api.goods.remove({ id: id }).then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList(1);
              }
            });
          }
        });
      } else {
        if (create_type == 1 || (create_type == 2 && type == 0)) {
          this.$api.goods.status({ id: id, status: type }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList(1);
            }
          });
        } else {
          // 弹出确认框
          this.$Modal.confirm({
            title: "警告",
            content: "<p>此商品为复制商品,请确认商品信息已修改再上架</p>",
            onOk: () => {
              this.$api.goods.status({ id: id, status: type }).then(res => {
                if (res.code == 200) {
                  this.$Message.success(res.msg);
                  this.getTableList(1);
                }
              });
            }
          });
        }

      }
    },
    change () { },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        is_platprice: "1",
        from_uuid: this.from_uuid,
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        is_hot: this.formItem.is_hot,
        is_pos: this.formItem.is_pos
      };
      this.$api.goods.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    formatDate (tt, fmt) {
      if (null == tt || "" == tt) return "";
      var date = new Date(tt);
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    // 更新平台进价最大值
    changePlatePrice (e) {
      for (var i in this.trandList) {
        if (this.trandList[i].seller_uuid == e) {
          if (this.trandList[i].saleinvoice == null) {
            this.maxPlatPrice = null;
            this.taxPoint = null;
            this.invoiceType = null;
            // break;
          } else {
            // console.log('this.trandList[i].seller_uuid',this.trandList[i])
            this.maxPlatPrice = this.trandList[i].saleinvoice.plat_price;
            this.taxPoint = this.trandList[i].saleinvoice.tax_point;
            this.invoiceType = this.trandList[i].saleinvoice.invoice_type;
            // break;
          }

          break;
        }
      }
    },
    removeSpec (specindex) {
      this.goodsSpecList.splice(specindex, 1);
    },
    getTagColor (index) {
      var color = "red";
      switch (index % 3) {
        case 1:
          color = "blue";
          break;
        case 2:
          color = "green";
          break;
        default:
          break;
      }
      return color;
    },
    showAllSepc () {
      var arr = [];
      for (let i = 0; i < this.goodsSpecType.length; i++) {
        const specType = this.goodsSpecType[i];
        for (let j = 0; j < specType.goodspecitem.length; j++) {
          var spec = specType.goodspecitem[j];
          spec.name = specType.name;
        }
        arr.push(specType.goodspecitem);
      } // 处理成二维数组

      var specList = [];
      if (arr.length > 0) {
        specList = this.runSpecTypeList(arr);
      }
      var goodsSpecList = [];
      for (let i = 0; i < specList.length; i++) {
        const specArr = specList[i];
        var specName = "";
        var specId = "_";
        var temp = {
          invoice_title: "",
          good_price: 0,
          good_store: 0,
          specList: [],
          good_spec_key: "",
          good_spec_name: "",
          thumb: null,
          thumblist: []
        };
        if (Array.isArray(specArr)) {
          for (let j = 0; j < specArr.length; j++) {
            const cateSpec = specArr[j];
            specId += cateSpec.id;
            specId += "_";
            if (specName == "") {
              specName += cateSpec.name + ":" + cateSpec.item;
            } else {
              specName += " " + cateSpec.name + ":" + cateSpec.item;
            }
            var s = { name: cateSpec.name, item: cateSpec.item };
            temp.specList.push(s);
            temp.good_spec_key = specId;
            temp.good_spec_name = specName;
            for (let k = 0; k < this.goodsSpecList.length; k++) {
              var goodsSpec = this.goodsSpecList[k];
              if (goodsSpec.good_spec_key == temp.good_spec_key) {
                temp = goodsSpec;
                break;
              }
            }
            temp.thumblist = [];
            if (temp.thumb != null && temp.thumb != "") {
              temp.thumblist.push({
                name: temp.thumb,
                url: temp.thumb,
                status: "finished"
              });
            }
          }
        } else {
          specId += specArr.id;
          specId += "_";
          if (specName == "") {
            specName += specArr.name + ":" + specArr.item;
          } else {
            specName += " " + specArr.name + ":" + specArr.item;
          }
          var s = { name: specArr.name, item: specArr.item };
          temp.specList.push(s);
          temp.good_spec_key = specId;
          temp.good_spec_name = specName;
          for (let k = 0; k < this.goodsSpecList.length; k++) {
            var goodsSpec = this.goodsSpecList[k];
            if (goodsSpec.good_spec_key == temp.good_spec_key) {
              temp = goodsSpec;
              break;
            }
          }
          temp.thumblist = [];
          if (temp.thumb != null && temp.thumb != "") {
            temp.thumblist.push({
              name: temp.thumb,
              url: temp.thumb,
              status: "finished"
            });
          }
        }
        goodsSpecList.push(temp);
      }
      // console.log(goodsSpecList)
      this.goodsSpecList = goodsSpecList;
    },
    runSpecTypeList (array) {
      // 笛卡尔积算法
      //这里array只有一个元素的时候会处理成对象
      //if( array.length < 2 ) return array[0] || [];
      return [].reduce.call(array, function (col, set) {
        var res = [];
        col.forEach(function (c) {
          set.forEach(function (s) {
            var t = [].concat(Array.isArray(c) ? c : [c]);

            t.push(s);
            res.push(t);
          });
        });
        return res;
      });
    },
    addNewSpec_y () {
      var specName = "";
      var specId = "_";
      var temp = {
        invoice_title: "",
        good_price: "",
        good_store: 0,
        specList: [],
        good_spec_key: "",
        good_spec_name: ""
      };
      for (let i = 0; i < this.goodsSpecType.length; i++) {
        const cateSpec = this.goodsSpecType[i];
        if (
          cateSpec.selectItemId == null ||
          cateSpec.selectItemId == undefined ||
          cateSpec.selectItemId == ""
        ) {
          this.$Message.error("规格" + cateSpec.name + "未选择");
          return;
        }
        for (let j = 0; j < cateSpec.goodspecitem.length; j++) {
          const spec = cateSpec.goodspecitem[j];
          if (spec.id == cateSpec.selectItemId) {
            specId += spec.id;
            specId += "_";
            if (specName == "") {
              specName += cateSpec.name + ":" + spec.item;
            } else {
              specName += " " + cateSpec.name + ":" + spec.item;
            }
            var s = { name: cateSpec.name, item: spec.item };
            temp.specList.push(s);
            temp.good_spec_key = specId;
            temp.good_spec_name = specName;
            break;
          }
        }
      }
      for (let i = 0; i < this.goodsSpecList.length; i++) {
        const gs = this.goodsSpecList[i];
        if (gs.good_spec_key == temp.good_spec_key) {
          this.$Message.error("规格" + temp.good_spec_name + "已存在");
          return;
        }
      }
      this.goodsSpecList.push(temp);
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
